import { defaultRtn } from "../declareTypes";

/** 数字处理 */
const numberHandle = () => { };

/**
 * 生成从[最小数]到[最大数]的随机数
 * @param minNum 最小数
 * @param maxNum 最大数
 * @returns 返回随机数
 */
numberHandle.random = (minNum: number, maxNum: number) => {
  const rtn = defaultRtn();
  try {
    /** 取值范围的差 */
    var range = maxNum - minNum;
    /** 小于1的随机数 */
    var random = Math.random();
    /** 最小数与随机数和取值范围求和，返回想要的随机数字 */
    rtn.data = minNum + Math.round(random * range);
    rtn.success = true;
  }
  catch (error: any) {
    rtn.message = '错误！';
    if (error) {
      const { message } = error;
      rtn.message = `错误！${message}`;
    }
  }
  return rtn;
};

/**
 * 转换为16进制
 * @param num 整数
 * @param options 选项
 * @returns 
 */
numberHandle.toHex16 = (num: bigint,
  options?: { isUpperCase?: boolean }) => {
  const rtn = defaultRtn();
  try {
    const { isUpperCase } = options || {};
    const buffer = new ArrayBuffer(8);
    const view = new DataView(buffer);
    // 处理有符号64位整数
    view.setBigInt64(0, num);
    let hex = '';
    for (let i = 0; i < 8; i++) {
      const byte = view.getUint8(i);
      hex += (isUpperCase === true ? byte.toString(16).toUpperCase() : byte.toString(16)).padStart(2, '0');
    }
    rtn.data = hex;
    rtn.success = true;
  }
  catch (error: any) {
    rtn.message = '错误！';
    if (error) {
      const { message } = error;
      rtn.message = `错误！${message}`;
    }
  }
  return rtn;
};

/**
 * 按比例分配
 * @param total 数字
 * @param ratios 比例
 * @example numberHandle.distributeByRatio(48, [2,3,5]) => [10, 14, 24] (2:3:5) 
 * @returns 
 */
numberHandle.distributeByRatio = (total: number, ratios: Array<number>) => {
  const rtn = defaultRtn();
  try {
    const sumRatios = ratios.reduce((a, b) => a + b, 0);
    if (sumRatios > 0) {
      /** 计算精确分配值并保留小数位信息 */
      const exactValues = ratios.map(r => ({
        int: Math.floor(total * r / sumRatios),
        decimal: (total * r) % sumRatios  // 网页1建议的数学运算应用[1](@ref)
      }));
      /** 计算待分配的余数值 */
      let remaining = total - exactValues.reduce((sum, v) => sum + v.int, 0);
      /** 按小数位降序排序创建索引队列 */
      const sortedIndexes = exactValues
        .map((v, i) => ({ index: i, value: v.decimal }))
        .sort((a, b) => b.value - a.value)
        .map(x => x.index);
      // 分配余数（网页1建议的运算逻辑扩展[1](@ref)）
      while (remaining-- > 0) {
        const targetIndex = sortedIndexes[remaining % sortedIndexes.length];
        exactValues[targetIndex].int++;
      }
      rtn.success = true;
      rtn.data = exactValues.map(v => v.int);
    } else {
      rtn.message = '比例总和必须大于0';
    }
  }
  catch (error: any) {
    rtn.message = '错误！';
    if (error) {
      const { message } = error;
      rtn.message = `错误！${message}`;
    }
  }
  return rtn;
};

/**
 * 格式化数字
 * @param num 数字
 * @param options 选项 
 * @returns 
 */
numberHandle.formatNumber = (num: number,
  options?: {
    /** 保留几位小数，默认:1 */
    digits?: number;
  }): string => {
  const { digits = 1 } = options || {};
  if (Math.abs(num) < 1000) return num.toString();
  const units = ['k', 'M', 'B', 'T'];
  const order = Math.floor(Math.log10(Math.abs(num)) / 3);
  const unit = units[order - 1] ?? '';
  const value = num / Math.pow(10, order * 3);
  // 保留指定位数并去除多余的尾零
  const formatted = value.toFixed(digits).replace(/\.?0+$/, '');
  return formatted + unit;
};

export default numberHandle;